<template>
  <div class="btn-scroll-to-top" :class="{ 'show': isShown }">
    <!-- We have wrapper because ripple effect give position relative to this absolute positioned btn -->
    <!-- Hence due to that our btn get lost -->
    <button
      type="button"
      class="btn btn-primary scroll-to-top-button"
      @click="scrollToTop"
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <ArrowUp :size="16" :stroke-width="2" />
    </button>
  </div>
</template>
<script>
import { ref, watch } from 'vue';
import { useWindowScroll } from '@vueuse/core';
import Ripple from '@core/directives/ripple';
import { defineComponent } from 'vue';
import ArrowUp from '@core/icons/ArrowUp.vue';

export default defineComponent({
  components: {
    ArrowUp,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { y } = useWindowScroll();
    const isShown = ref(false);

    // Watch the scroll position
    watch(y, (newY) => {
      isShown.value = newY > 250;
    }, { deep: true });

    const scrollToTop = () => {
      const rootEle = document.documentElement;
      rootEle.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    return { y, isShown, scrollToTop };
  },
});
</script>

<style lang="scss" scoped>
.btn-scroll-to-top {
  position: fixed;
  bottom: 5%;
  right: 30px;
  z-index: 99;
  opacity: 0;
  transition: all 0.5s ease;

  &.show {
    opacity: 1;
  }
}

.scroll-to-top-button {
  width: 38px;
  height: 38px;
  padding: 0;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  :deep(.yn-svg-icon) {
    display: block;
    width: 16px;
    height: 16px;
    color: #fff;
    stroke: #fff;
  }
}
</style>
